/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Prevent click on current variant in fake variant selector */
document.addEventListener('click', function(evt){
  if ( evt.target.closest('.block-swatch__item--active') || evt.target.closest('.color-swatch__item--active') ) {
    evt.preventDefault();
  }
});

document.addEventListener("rebuy:cart.change", function (event) {
  console.debug("rebuy:cart.change event", event);
  // console.debug(event.detail.cart.cart["item_count"]);
  document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: event.detail.cart.cart,
          openMiniCart: false
        },
      })
  );
});

/* region Klaviyo Add To Cart code */
window.addEventListener('load', function() {
  var _learnq = window._learnq || [];
  var klAjax = true; // Seems to be a way to make sure ATC is tracked only once.
  document.addEventListener('cart:updated', function(event) {
    if (klAjax) {
      let data = event.detail.cart; // Get the updated content of the cart
      let cart_for_klaviyo = {
        total_price: data.total_price/100,
        $value: data.total_price/100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price/100,
        items: data.items
      }
      _learnq.push(['track', 'Added to Cart Shopify', cart_for_klaviyo]);
      // console.log('Klaviyo cart:updated ATC fired');
      // console.log({cart_for_klaviyo});
      klAjax = false;
    }
  });
  document.addEventListener('variant:added', function(event) {
    let variant = event.detail.variant; // Get the variant that was added
    _learnq.push(['track', 'Added to Cart Shopify', variant]);
    // console.log('Klaviyo variant:added ATC fired');
    // console.log({variant});
    klAjax = false;
  });
});
/* endregion */

/**
 * Lazy-load <video class="js-lazy-video">
 * when they approach the viewport.
 *
 * Expected markup:
 *  - Videos:  <video class="js-lazy-video" data-src="..." preload="none" ...></video>
 *        OR:  <video class="js-lazy-video" preload="none"><source data-src="..." type="video/mp4"></video>
 */
(function () {
  const VIDEO_SELECTOR = "video.js-lazy-video";

  function hydrateVideo(video) {
    if (!video || video.dataset.hydrated === "1") return;

    // Case A: <video data-src="...">
    if (video.dataset.src) {
      video.src = video.dataset.src;
    }

    // Case B: <source data-src="...">
    const sources = video.querySelectorAll("source[data-src]");
    sources.forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute("data-src");
    });

    // Trigger fetch
    video.load();

    // If autoplay is desired, try to start (muted autoplay usually works)
    if (video.hasAttribute("autoplay")) {
      const p = video.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    }

    video.dataset.hydrated = "1";
  }

  function hydrateEl(el) {
    if (!el) return;
    else if (el.tagName === "VIDEO") hydrateVideo(el);
  }

  function getTargets(root = document) {
    const videos = Array.from(root.querySelectorAll(VIDEO_SELECTOR));
    return videos.filter((el) => el.dataset.hydrated !== "1");
  }

  function init() {
    const targets = getTargets();

    if (!targets.length) return;

    // Fallback if IntersectionObserver is unavailable
    if (!("IntersectionObserver" in window)) {
      window.addEventListener(
          "load",
          () => targets.forEach(hydrateEl),
          { once: true }
      );
      return;
    }

    const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            hydrateEl(entry.target);
            io.unobserve(entry.target);
          }
        },
        {
          root: null,
          rootMargin: "300px 0px", // start loading a bit before it’s visible
          threshold: 0.01,
        }
    );

    targets.forEach((t) => io.observe(t));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();

/** End lazy load region **/
